import { UseEntityRecordMatcherProps } from '../types';

import { getTargetEntityRecordMatcherConfig } from './entity-record-matcher-configs/get-target-entity-record-matcher-config';
import { TargetEntityRecordMatcherConfigs } from './types';

type Props = Pick<UseEntityRecordMatcherProps, 'targetEntity' | 'options'>;

type Return<TData> = {
  config: TargetEntityRecordMatcherConfigs<TData>;
  skip: boolean;
};

export const resolveEntityRecordMatcherOptions = <TData>({
  targetEntity,
  options = { skip: false },
}: Props): Return<TData> => {
  const config = getTargetEntityRecordMatcherConfig<TData>({
    targetEntity,
  });

  const skip = options.skip || !config;

  return {
    config,
    skip,
  };
};
